export default __webpack_public_path__ + "static/media/CorePro.f7ee9990.png";